export default "__VITE_ASSET__BasEZQ5e__"